import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import AuthService from "services/auth-service";

const TransactionSummary = ({ transactions, selectedAccount, selectedMonth, onTotalChange }) => {
  const [data, setData] = useState({
    incomes: 0,
    outcomes: 0,
    balancing: 0,
    total: 0
  });
  
  useEffect(() => {
    const fetchData = async () => {
      if (!selectedAccount || !selectedMonth) {
        return ;
      }
      const payload = {
        account_id: selectedAccount.id,
        from: selectedMonth.format("YYYYMM"),
        to: selectedMonth.format("YYYYMM"),
      };
      let data = await AuthService.fetchSummaries("first_day_snapshot", payload);
      const total = Object.values(data)?.[0]?.[0]?.amount ?? 0;
      preSetData({ ...data, total: total });
    };
    fetchData();
  }, [selectedAccount, selectedMonth]);

  const preSetData = (data) => {
    setData(data);
    onTotalChange(data.total + data.balancing);
  };

  useEffect(() => {
    const incomes = transactions
      .filter((transaction) => transaction.amount > 0)
      .reduce((sum, transaction) => sum + transaction.amount, 0);

    const outcomes = transactions
      .filter((transaction) => transaction.amount < 0)
      .reduce((sum, transaction) => sum + transaction.amount, 0);

      preSetData({
      ... data,
      incomes: incomes,
      outcomes: outcomes,
      balancing: (incomes + outcomes),
    });
  }, [transactions]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={3} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="success"
            icon="login"
            title="Incomes"
            count={new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: selectedAccount?.currency ?? "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(Math.abs(data.incomes) / 100)}
            percentage={{
              color: data.incomes > 0 ? "success" : "error",
              amount: "",
              label: "Just updated",
            }}
          />
        </MDBox>
      </Grid>
      <Grid item xs={12} md={3} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="primary"
            icon="logout"
            title="Outcomes"
            count={new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: selectedAccount?.currency ?? "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(Math.abs(data.outcomes) / 100)}
            percentage={{
              color: data.outcomes > 0 ? "success" : "error",
              amount: "",
              label: "Just updated",
            }}
          />
        </MDBox>
      </Grid>
      <Grid item xs={12} md={3} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="dark"
            icon="balance"
            title="Balance"
            count={new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: selectedAccount?.currency ?? "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(Math.abs(data.balancing) / 100)}
            percentage={{
              color: data.balancing > 0 ? "success" : "error",
              amount: "",
              label: "Just updated",
            }}
          />
        </MDBox>
      </Grid>
      <Grid item xs={12} md={3} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="warning"
            icon="monetization_on"
            title="Total"
            count={new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: selectedAccount?.currency ?? "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(Math.abs(data.total + data.balancing) / 100)}
            percentage={{
              color: "dark",
              amount: "",
              label: "Just updated",
            }}
          />
        </MDBox>
      </Grid>
    </Grid>
  );
};

export default TransactionSummary;
